module.exports = __webpack_public_path__ + "static/media/background-form.57b318ae.png";